import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { AuthorizationModel } from 'src/app/shared/models/authorization-model';
import { TextInputModel } from '../../models/text-input.model';

@Component({
  selector: 'ness-inline-edit-text',
  templateUrl: './inline-edit-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./inline-edit-text.component.scss']
})
export class InlineEditTextComponent implements AfterViewInit {

  private _orginalValue: any;
  private _textInputModel: TextInputModel = null;
  @Input() set textInputModel(inputModel: TextInputModel) {
    this._textInputModel = { ...inputModel };
    this._orginalValue = inputModel.dataValue;
  }
  get textInputModel(): TextInputModel {
    return this._textInputModel;
  }

  @Input() canEdit: boolean = false;
  @Output() onSave: EventEmitter<string> = new EventEmitter<string>();

  public editing: boolean = false;
  public inputReqValue: boolean = false;

  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngAfterViewInit() {
    this._setDisabledAttribute();
  }

  private _setDisabledAttribute() {
    let editBtnEl: HTMLButtonElement = this.el.nativeElement.querySelector('#editBtn');
    if (editBtnEl) {
      if (this.textInputModel.disabled) {
        this.renderer.setAttribute(editBtnEl, 'disabled', 'true');
      } else {
        this.renderer.removeAttribute(editBtnEl, 'disabled');
      }
    }
  }

  public save() {
    if (!this.textInputModel.required) {
        this.onSave.emit(this.textInputModel.dataValue);
        this.editing = !this.editing;
    }
  }

  public cancelEdit() {
    this.editing = !this.editing;
    this.textInputModel.dataValue = this._orginalValue;
  }

  public toggleEdit() {
    this.editing = !this.textInputModel.disabled && !this.editing;
  }
}
